import blaizeImage from './images/blaize.svg';
import kaylaImage from './images/kayla.svg';
import sueImage from './images/sue.svg';

const people = [
  {
    image: kaylaImage.src,
    name: 'Kayla',
    quote:
      'I’m an uncomplicator. My job is to make your life easier by giving you all the complicated stuff in a way that’s easy to understand.',
    startYear: 2017,
  },
  {
    image: sueImage.src,
    name: 'Sue',
    quote:
      'I’m a problem solver. I get into the details if there’s an issue and find a better way to do things. And if a member needs to go to hospital or make a claim, I can help with that too.',
    startYear: 2015,
  },
  {
    image: blaizeImage.src,
    name: 'Blaize',
    quote:
      'I’m a simplifier. I’m here to make choosing cover easier and help you find the right type of cover based on you and your needs.',
    startYear: 2016,
  },
];

export default people;
